<script>
import Layout from "../../layouts/main";
import Banner from "@/components/banner.vue"
import FaqS from "@/components/faqComponent.vue"
import ClaimApi from "@/services/claim-api";


export default ({
  name: "Faq",

  components: {
    Layout, Banner ,FaqS
  },

    data() {
        return{
            contactUs:{ firstName: '' , secondName: '' , mail: '' , message:''},
        }
    },

    methods :{
      sendContactUsMail(){
        ClaimApi.sendContactUsMail(this.contactUs)
      }
    }
      
});


</script>

<template>
  <Layout>
    <Banner pageTitle='Contactez-nous' subtitle1="ype and scrambled it to make a type specimen book. It has" subtitle2="survived not only five centuries, " :imageBackGround="false" :small="true" ></Banner>

<div style="overflow: hidden ">
    <img src="../../../assets/images/ha-stores-map-monochrome.png" width="100%" height="100%"  >
</div>

<div class="row" >
    <div class="col-12" style="display: contents;">
        <div class="col-lg-2 col-sm-1"/>
        <div class="col-lg-8 col-sm-10 p-5"  style="background-color: white; transform: translate(0px , -50px); " >
            
                <div class="row mt-3">
                    <div class="col-12" style="display: contents">
                    <div class="col-lg-6 col-sm-12 pr-md-4 ">
                        <b-form-group>
                          <label for="ref" class="font-size-16 text-info font-weight-bold ">Nom  </label>
                          <input
                          placeholder="Nom"
                          id="ref"
                          type="text"
                          class="form-control font-size-16"
                          v-model="contactUs.secondName"
                          />
                        </b-form-group>

                    </div>
                    <div class="col-lg-6 col-sm-12  " style="height: 52px;">
                        <b-form-group>
                          <label for="ref" class="font-size-16 text-info font-weight-bold ">Prénom</label>
                          <input
                          placeholder="Prénom"
                          id="ref"
                          type="text"
                          class="form-control font-size-16"
                          v-model="contactUs.firstName"
                          />
                        </b-form-group>

                    </div>

                    </div>
                </div>

             

                <div class="pr-md-6 mt-3">

                <b-form-group>
                    <label for="ref" class="font-size-16 text-info font-weight-bold  mt-3"> Adresse mail</label>
                    <input
                    placeholder="Adresse mail"
                    id="ref"
                    type="text"
                    class="form-control font-size-16"
                    v-model="contactUs.mail"
                    />
                </b-form-group>

                <b-form-group>
                    <label for="ref" class="font-size-16 text-info font-weight-bold  mt-3"> Message</label>
                <textarea
                    placeholder="Votre message"
                    v-model="contactUs.message"
                    class="form-control"
                    :maxlength="3000"
                    rows="10"
                  ></textarea>
                </b-form-group>

            

                <b-button  variant="dark" class="getStarted1 font-size-18 text-dark btn-block mt-5 " @click="sendContactUsMail() ">Envoyer</b-button>

            </div>

        </div>
        <div class="col-lg-2 col-sm-1"/>

    </div>

</div>


<FaqS title="Conditions générales de ventes" :faqType="0" > </FaqS>

    

  </Layout>
</template>
<style scoped>


</style>
